<main class="p-5 flex flex-col gap-7 bg-white">
  @if(user) {
  <app-banner [firstname]="user.firstName" />
  }
  <div class="flex gap-3" *appCan="dashboardAccess">
    <p-iconfield style="width: 20.75rem; height: 2.5rem;">
      <p-inputicon styleClass="pi pi-search" />
      <input
        type="text"
        pInputText
        class="w-full h-full"
        [placeholder]="DashboardTranslateKeys.SEARCH_PLACEHOLDER | translate"
      />
    </p-iconfield>

    @if(canSelectJobOwner) {
    <div class="relative" style="width: 274px; height: 2.5rem;">
      <label for="filterByOwner" class="absolute top-1 left-3 font-medium uppercase tracking-wide text-[#626F86] z-10 pointer-events-none" style="font-size: 0.5rem;">
        {{ DashboardTranslateKeys.RECRUITER | translate }}
      </label>
      <p-multiselect
        inputId="filterByOwner"
        class="w-full h-full"
        styleClass="multiselect-with-label"
        [options]="employees"
        optionLabel="displayName"
        optionValue="id"
        [showClear]="true"
        [filter]="true"
        (onFilter)="loadEmployees($event.filter)"
        [placeholder]="DashboardTranslateKeys.ALL | translate"
        [(ngModel)]="selectedJobOwners"
        variant="filled"
      >
      </p-multiselect>
    </div>
    }
  </div>

  <app-recruitment-perf
    *appCan="dashboardAccess"
    [selectedJobOwners]="selectedJobOwners"
  />
  <app-job-offer-tracking
    *appCan="dashboardAccess"
    [selectedJobOwners]="selectedJobOwners"
  />
  <app-process-efficiency
    *appCan="dashboardAccess"
    [selectedJobOwners]="selectedJobOwners"
  />
  <br />
</main>
